export default "__VITE_ASSET__BYjjr2aM__"